import React from 'react'
import PropTypes from 'prop-types'

import { getMobileOSPlatform, } from 'lib/featureTest'

const defaultPlatform = getMobileOSPlatform()

const ShareIcon = ({ customClassName, width, height, fill, platform = defaultPlatform, }) => {
  if (platform === 'android') {
    return (
      <svg
        className={customClassName}
        width={width}
        height={height}
        aria-labelledby="Share"
        viewBox="0 0 60 60"
        style={{
          enableBackground: 'new 0 0 60 60',
        }}
      >
        <title id="share-icon">Share</title>
        <g>
          {/* no need for the circular outline...
          <path
            fill={fill}
            d="M30,0C13.458,0,0,13.458,0,30s13.458,30,30,30s30-13.458,30-30S46.542,0,30,0z M30,58C14.561,58,2,45.439,2,30
            S14.561,2,30,2s28,12.561,28,28S45.439,58,30,58z"
          />*/}
          <path
            fill={fill}
            d="M39,20c3.309,0,6-2.691,6-6s-2.691-6-6-6c-3.131,0-5.705,2.411-5.973,5.474L18.961,23.788C18.086,23.289,17.077,23,16,23
            c-3.309,0-6,2.691-6,6s2.691,6,6,6c1.077,0,2.086-0.289,2.961-0.788l14.065,10.314C33.295,47.589,35.869,50,39,50
            c3.309,0,6-2.691,6-6s-2.691-6-6-6c-2.69,0-4.972,1.78-5.731,4.223l-12.716-9.325C21.452,31.848,22,30.488,22,29
            s-0.548-2.848-1.448-3.898l12.716-9.325C34.028,18.22,36.31,20,39,20z M39,10c2.206,0,4,1.794,4,4s-1.794,4-4,4s-4-1.794-4-4
            S36.794,10,39,10z M12,29c0-2.206,1.794-4,4-4s4,1.794,4,4s-1.794,4-4,4S12,31.206,12,29z M39,40c2.206,0,4,1.794,4,4s-1.794,4-4,4
            s-4-1.794-4-4S36.794,40,39,40z"
          />
        </g>
      </svg>
    )
  }

  // return ios by default
  return (
    <svg
      className={customClassName}
      width={width}
      height={height}
      aria-labelledby="Share"
      viewBox="0 0 333.324 383.324"
      style={{
        enableBackground: 'new 0 0 333.324 383.324',
      }}
    >
      <title id="share-icon">Share</title>
      <g>
        <path
          fill={fill}
          d="M125.255,59.513l33.907-33.907v149.451c0,4.143,3.358,7.5,7.5,7.5s7.5-3.357,7.5-7.5V25.606
          l33.907,33.907c1.464,1.464,3.384,2.196,5.303,2.196s3.839-0.732,5.303-2.196c2.929-2.93,2.929-7.678,0-10.607l-46.71-46.71
          c-2.929-2.928-7.678-2.928-10.606,0l-46.71,46.71c-2.929,2.93-2.929,7.678,0,10.607C117.577,62.441,122.326,62.441,125.255,59.513z"
        />
        <path
          fill={fill}
          d="M263.328,87.557h-61.645c-4.142,0-7.5,3.357-7.5,7.5s3.358,7.5,7.5,7.5h54.145v215.767H77.495
          V102.557h54.145c4.142,0,7.5-3.357,7.5-7.5s-3.358-7.5-7.5-7.5H69.995c-4.142,0-7.5,3.357-7.5,7.5v230.767
          c0,4.143,3.358,7.5,7.5,7.5h193.333c4.142,0,7.5-3.357,7.5-7.5V95.057C270.828,90.915,267.47,87.557,263.328,87.557z"
        />
      </g>
    </svg>
  )
}

ShareIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  customClassName: PropTypes.string,
  fill: PropTypes.string,
  platform: PropTypes.oneOf([
    'ios',
    'android',
  ]),
}

ShareIcon.defaultProps = {
  width: 20,
  height: undefined,
  customClassName: '',
  fill: '#222220',
  platform: 'ios',
}

export default ShareIcon



// WEBPACK FOOTER //
// ./src/components/icons/Share.js